import { IColumn, IDropdownOption } from "@fluentui/react";

export const _columns: IColumn[] = [
  {
    key: "country",
    name: "Country",
    fieldName: "country",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
    isSorted: true,
    isSortedDescending: true,
  },
  {
    key: "authority",
    name: "Authority",
    fieldName: "authority",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "position",
    name: "Position",
    fieldName: "position",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "teamName",
    name: "Team",
    fieldName: "teamName",
    minWidth: 100,
    maxWidth: 100,
    isResizable: true,
  },
  {
    key: "firstName",
    name: "First name",
    fieldName: "firstName",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "lastName",
    name: "Last name",
    fieldName: "lastName",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "email",
    name: "Email",
    fieldName: "email",
    minWidth: 100,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "professionalPhoneNumber",
    name: "Professional telephone no",
    fieldName: "professionalPhoneNumber",
    minWidth: 170,
    maxWidth: 200,
    isResizable: true,
  },
  {
    key: "legalFrameworkDepartment",
    name: "Legal framework - department",
    fieldName: "legalFrameworkDepartment",
    minWidth: 170,
    maxWidth: 200,
    isResizable: true,
  },
];

export const initialSearchContacts = {
  firstName: "",
  lastName: "",
  country: "",
  authority: "",
  legalFrameworkDepartment: ""
};

export const defaultContactValues = {
  firstName: "",
  lastName: "",
  country: "",
  authority: "",
  position: "",
  team: "",
  genericEmail: "",
  professionalEmail: "",
  professionalPhone: "",
  legalFrameworkDepartment: ""
};
